var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAtendimento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#0A518F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47869 15.5H5.84801L9.51207 5.31818H11.2869L14.951 15.5H13.3203L10.4418 7.16761H10.3622L7.47869 15.5ZM7.75213 11.5128H13.0419V12.8054H7.75213V11.5128Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#0A518F",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtendimento);
export default __webpack_public_path__ + "static/media/atendimento.695e096659d9cbde0e2be2c0087893d1.svg";
export { ForwardRef as ReactComponent };